import { render, staticRenderFns } from "./register_trading.vue?vue&type=template&id=a3dd49b4&scoped=true&"
import script from "./register_trading.vue?vue&type=script&lang=js&"
export * from "./register_trading.vue?vue&type=script&lang=js&"
import style0 from "./register_trading.vue?vue&type=style&index=0&id=a3dd49b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dd49b4",
  null
  
)

export default component.exports